export enum Video {
  VIDEO_BASIC_EXPERIENCE = 'VIDEO_BASIC_EXPERIENCE', // 경험 기반 면접
  VIDEO_BASIC_SITUATION = 'VIDEO_BASIC_SITUATION', // 상황 면접
  VIDEO_BASIC_VALUES = 'VIDEO_BASIC_VALUES', // 가치관 면접
  VIDEO_BASIC_FREE_CHOICE = 'VIDEO_BASIC_FREE_CHOICE ', // 질문 선택 면접
}

export const videoTypeStringMap: Record<VideoType, string> = {
  VIDEO_BASIC_EXPERIENCE: '경험 기반',
  VIDEO_BASIC_SITUATION: '상황',
  VIDEO_BASIC_VALUES: '가치관',
  VIDEO_BASIC_FREE_CHOICE: '질문 선택',
};

export type VideoType = keyof typeof Video;
